import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Header } from "../../features/kquant/components/Header";

import "./flow/styles/flow-scope.css";
import "@xyflow/react/dist/style.css";

import MainLayout from "./flow/layouts/MainLayout";
import DagStudioPage from "./flow/pages/DagStudioPage";
import BacktestPage from "./flow/pages/BacktestPage";
import { FlowDirtyProvider } from "./flow/contexts/FlowDirtyContext";
import { FlowUnsavedChangesGuard } from "./flow/components/FlowUnsavedChangesGuard";

export default function FlowAppRouter() {
  return (
    <div className="relative flex h-screen w-full flex-col overflow-hidden bg-slate-100 text-slate-800">
      
      {/* Header outside of scope to avoid button resets */}
      <div className="relative z-50 px-8">
        <Header />
      </div>

      <div className="my-quant-flows-scope relative z-0 flex min-h-0 flex-1 flex-col">
        <FlowDirtyProvider>
          <FlowUnsavedChangesGuard />
          <Routes>
            <Route element={<MainLayout />}>
              <Route index element={<Navigate to="/my-quant-flows" replace />} />
              <Route path="editor/:workflowId" element={<DagStudioPage />} />
              <Route path="backtest/:workflowId" element={<BacktestPage />} />
              <Route path="*" element={<Navigate to="/my-quant-flows" replace />} />
            </Route>
          </Routes>
        </FlowDirtyProvider>
      </div>
    </div>
  );
}
